import {detectOS} from 'functions/detectaos';
import linkandroid from 'assets/google-en.png';
import linkapple from 'assets/apple-en.png';
import './style.css';

function StoreLinks({ className = '', showTitle = true }) {
    const os = detectOS();
    const showAndroid = os !== 'iOS';
    const showIos = os !== 'Android';

    return (
        <div className={`store-links ${className}`.trim()}>
            {showTitle && <p className="store-links-title">
                <i className="fas fa-mobile-alt me-2"></i>
                Baixe o app
            </p>}
            <div className="store-links-badges">
                {showAndroid && (
                    <a
                        href="https://play.google.com/store/apps/details?id=br.com.opnet.actus&hl=pt_BR"
                        target="_blank"
                        rel="noreferrer"
                        aria-label="Baixar no Google Play"
                    >
                        <img src={linkandroid} alt="Baixar no Google Play" />
                    </a>
                )}
                {showIos && (
                    <a
                        href="https://apps.apple.com/br/app/actus/id6503474213"
                        target="_blank"
                        rel="noreferrer"
                        aria-label="Baixar na App Store"
                    >
                        <img src={linkapple} alt="Baixar na App Store" />
                    </a>
                )}
            </div>
        </div>
    );
}

export default StoreLinks;